import { injectIntl } from "react-intl";

const EventLogDropArea = (props) => {
  const { intl } = props;
  const { formatMessage } = intl;

  return (
    <div className="event-log-drag-gap">
      {formatMessage({
        id: "eventlog.drop-area",
        defaultMessage: "Drop Here",
      })}
    </div>
  )
}

export default injectIntl(EventLogDropArea);
